import axios from 'axios';

const WEBHOOK_URL = 'https://webhooks.integrately.com/a/webhooks/f616b78ad33b4586909a0a3ed22ffb0d';

export const subscribeToNewsletter = async (email: string): Promise<boolean> => {
  try {
    const response = await axios.post(WEBHOOK_URL, {
      email,
      timestamp: new Date().toISOString(),
      source: 'website_newsletter'
    });

    return response.status === 200;
  } catch (error) {
    console.error('Newsletter subscription error:', error);
    throw new Error('Failed to subscribe to newsletter. Please try again later.');
  }
};